import { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../../api/client';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/bcd-icon.png" alt="BCD" className="h-10 mx-auto mb-3" />
          <h1 className="text-2xl font-heading font-bold text-white uppercase tracking-wide">
            Reset Your Password
          </h1>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          {sent ? (
            <div className="text-center">
              <p className="text-txt-primary mb-2">
                If an account exists with that email, we've sent a reset link. Check your inbox.
              </p>
              <p className="text-sm font-bold text-txt-primary mb-4">
                Don't see it? Check your spam or junk folder.
              </p>
              <Link to="/login" className="text-gold-dark font-semibold hover:underline">
                Back to login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <p className="text-sm text-txt-secondary mb-2">
                Enter your email address and we'll send you a link to reset your password.
              </p>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="border border-gray-300 rounded-lg px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-gold"
              />
              {error && <p className="text-red-500 text-sm">{error}</p>}
              <button
                type="submit"
                disabled={loading}
                className="btn-gold w-full py-3 text-sm font-semibold disabled:opacity-50"
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
              <Link to="/login" className="text-center text-sm text-gold-dark font-semibold hover:underline">
                Back to login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
